import TioLoadingSpinner from 'tio-common/components/tio/loading-spinner';

<template>
  <div class="tio-row-center h-screen w-screen">
    <TioLoadingSpinner />
  </div>
</template>
